/*
 * Copyright (C) 2021 - Potentially Ltd
 *
 * Please see distribution for license.
 */
import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'ptl-content-store-finish',
  templateUrl: './content-store-finish.component.html',
  styleUrls: ['./content-store-finish.component.scss'],
})
export class ContentStoreFinishComponent {
  @Output() shareFinished = new EventEmitter<void>();

  closeDialog() {
    this.shareFinished.emit();
  }
}
